/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ACHTokenCreate } from '../models/ACHTokenCreate';
import type { ACHTokenCreateDetails } from '../models/ACHTokenCreateDetails';
import type { ACHTokenDetails } from '../models/ACHTokenDetails';
import type { ACHTokenExchangeCreateDTO } from '../models/ACHTokenExchangeCreateDTO';
import type { ACHTokenPaymentCreate } from '../models/ACHTokenPaymentCreate';
import type { ACHTokenUpdateDTO } from '../models/ACHTokenUpdateDTO';
import type { PaymentDetails } from '../models/PaymentDetails';
import { request as __request } from '../core/request';

export class AchTokensVService {

    /**
     * @param districtId
     * @param billingAccountId
     * @param recurringPayments
     * @returns ACHTokenDetails OK
     * @throws ApiError
     */
    public static async achTokensVGetAll(
        districtId?: string,
        billingAccountId?: string,
        recurringPayments?: boolean,
    ): Promise<Array<ACHTokenDetails>> {
        const result = await __request({
            method: 'GET',
            path: `/api/v1/ach/tokens`,
            query: {
                'DistrictId': districtId,
                'BillingAccountId': billingAccountId,
                'RecurringPayments': recurringPayments,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns ACHTokenCreateDetails Created
     * @throws ApiError
     */
    public static async achTokensVCreate(
        requestBody?: ACHTokenCreate,
    ): Promise<ACHTokenCreateDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v1/ach/tokens`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param achTokenId
     * @param isSaved
     * @returns ACHTokenDetails OK
     * @throws ApiError
     */
    public static async achTokensVGetById(
        achTokenId: string,
        isSaved: boolean = true,
    ): Promise<ACHTokenDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v1/ach/tokens/${achTokenId}`,
            query: {
                'isSaved': isSaved,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param achTokenId
     * @param requestBody
     * @returns ACHTokenCreateDetails OK
     * @throws ApiError
     */
    public static async achTokensVUpdate(
        achTokenId: string,
        requestBody?: ACHTokenUpdateDTO,
    ): Promise<ACHTokenCreateDetails> {
        const result = await __request({
            method: 'PUT',
            path: `/api/v1/ach/tokens/${achTokenId}`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param achTokenId
     * @returns any OK
     * @throws ApiError
     */
    public static async achTokensVDelete(
        achTokenId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v1/ach/tokens/${achTokenId}`,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param achTokenId
     * @param requestBody
     * @returns PaymentDetails OK
     * @throws ApiError
     */
    public static async achTokensVCharge(
        achTokenId: string,
        requestBody?: ACHTokenPaymentCreate,
    ): Promise<PaymentDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v1/ach/tokens/${achTokenId}/charge`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param achTokenId
     * @returns ACHTokenDetails OK
     * @throws ApiError
     */
    public static async achTokensVCreateRecurring(
        achTokenId: string,
    ): Promise<ACHTokenDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v1/ach/tokens/${achTokenId}/recurring`,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param achTokenId
     * @returns ACHTokenDetails OK
     * @throws ApiError
     */
    public static async achTokensVDeleteRecurring(
        achTokenId: string,
    ): Promise<ACHTokenDetails> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v1/ach/tokens/${achTokenId}/recurring`,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns ACHTokenCreateDetails OK
     * @throws ApiError
     */
    public static async achTokensVExchange(
        requestBody?: ACHTokenExchangeCreateDTO,
    ): Promise<ACHTokenCreateDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v1/ach/tokens/exchange`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
        return result.body;
    }

}